/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedRegionListAdmin } from './PaginatedRegionListAdmin'
import {
  PaginatedRegionListAdminFromJSON,
  PaginatedRegionListAdminFromJSONTyped,
  PaginatedRegionListAdminToJSON,
} from './PaginatedRegionListAdmin'

/**
 *
 * @export
 * @interface EnvelopedRegionListRegionListAdmin
 */
export interface EnvelopedRegionListRegionListAdmin {
  /**
   *
   * @type {PaginatedRegionListAdmin}
   * @memberof EnvelopedRegionListRegionListAdmin
   */
  body: PaginatedRegionListAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedRegionListRegionListAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedRegionListRegionListAdmin interface.
 */
export function instanceOfEnvelopedRegionListRegionListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedRegionListRegionListAdminFromJSON(
  json: any,
): EnvelopedRegionListRegionListAdmin {
  return EnvelopedRegionListRegionListAdminFromJSONTyped(json, false)
}

export function EnvelopedRegionListRegionListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedRegionListRegionListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedRegionListAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedRegionListRegionListAdminToJSON(
  value?: EnvelopedRegionListRegionListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedRegionListAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
